<template>
  <div class="xcbf">
    <div
      class="info-body"
      :class="{ 'remote-control': $store.getters.isRemoteControl }"
    >
      <div class="title">内网穿透</div>
      <div class="desc">无需公网IP 无需端口映射</div>
      <div class="slogan-wrap">
        <div class="slogan-item">
          <div class="slogan-icon slogan-icon-01"></div>
          <div class="slogan-text">无需配置</div>
        </div>
        <div class="slogan-item">
          <div class="slogan-icon slogan-icon-02"></div>
          <div class="slogan-text">一键远程</div>
        </div>
        <div class="slogan-item">
          <div class="slogan-icon slogan-icon-03"></div>
          <div class="slogan-text">高速传输</div>
        </div>
      </div>
      <div class="login-btn" @click="showLogin" v-if="!$store.state.user.uid">
        立即登录
      </div>
      <div class="login-btn" @click="showAddDevice" v-else>立即绑定</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showLogin: function () {
      this.$store.state.isShowLogin = true;
    },
    showAddDevice: function () {
      this.$store.state.isShowAddDevice = true;
    },
  },
  mounted: function () {},
};
</script>

<style lang="less">
</style>

<style lang="less" scoped>
.xcbf {
  padding-top: 1px;
  position: relative;

  .info-body.remote-control {
    background-image: none;
  }

  .info-body {
    margin-left: 80px;
    margin-top: 50px;
    background-image: url(../../assets/components/node/empty/bg.png);
    background-size: 375px 190px;
    background-repeat: no-repeat;
    background-position: top 40px right 120px;
  }
  .title {
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.25);
    font-family: PingFang SC;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    color: #3535c1;
    background: var(
      --unnamed,
      linear-gradient(188deg, #655de1 0%, #3535c1 100%)
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .desc {
    color: var(--h-24-a-4-a-4-a, #4a4a4a);
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 6px;
  }
  .slogan-wrap {
    width: 430px;
    height: 41px;
    flex-shrink: 0;
    border-radius: 24px;
    text-align: left;
    margin-top: 20px;
    .slogan-item {
      display: inline-block;
      vertical-align: top;
      margin-top: 6px;
      text-align: left;
      .slogan-icon {
        width: 28px;
        height: 28px;
        flex-shrink: 0;
        display: inline-block;
        vertical-align: top;
        background-size: 100% 100%;
      }
      .slogan-icon-01 {
        background-image: url(../../assets/components/node/empty/slogan-01.png);
      }
      .slogan-icon-02 {
        background-image: url(../../assets/components/node/empty/slogan-02.png);
      }
      .slogan-icon-03 {
        background-image: url(../../assets/components/node/empty/slogan-03.png);
      }
      .slogan-text {
        display: inline-block;
        vertical-align: top;
        height: 28px;
        line-height: 28px;
        margin-right: 24px;
        margin-left: 4px;
        font-size: 14px;
        color: #3535c1;
        background: var(
          --unnamed,
          linear-gradient(188deg, #655de1 0%, #3535c1 100%)
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .slogan-item:last-child {
      .slogan-text {
        margin-right: 0;
      }
    }
  }

  .login-btn {
    width: 167px;
    height: 42px;
    flex-shrink: 0;
    border-radius: 24px;
    background-color: #3535c1;
    background-image: var(
      --unnamed,
      linear-gradient(188deg, #655de1 0%, #3535c1 100%)
    );
    box-shadow: 0px 2px 6px 0px rgba(79, 87, 163, 0.24);
    color: #f8f3ff;
    text-shadow: 0px 1px 1px rgba(119, 80, 3, 0.25);
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 42px;
    text-align: center;
    margin-top: 55px;
  }
  .login-btn:hover {
    cursor: pointer;
    opacity: 0.9;
  }
}
</style>